import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import connect from "react-redux/es/connect/connect";
import FusePageCarded from "../../../@fuse/components/FusePageLayouts/FusePageCarded";

import WatchList from '../dashboard/components/WatchList';
import OrdersList from '../dashboard/components/OrderList';
import {API} from "../../../config";
import { companySelector } from '../../../store/reducers/company.reducer';

import Util from '../../../yeffect/utils';
import classNames from 'classnames';

const sell_orders = API.service('sell-orders');
const buy_orders = API.service('buy-orders');
const completed_trades = API.service('completed-trades');

const styles = theme => ({
  layoutRoot: {
    backgroundColor: '#23272f',
    display: 'flex',
    flex: 1,
    height: '100vh',
    overflow: 'hidden'
  },
  container: {
    flex: '1 0 auto',
  },
  content: {
    height: '100%',
    padding: 10,
    backgroundColor: '#23272f',
  },
  dataContainer: {
    height: 'calc(100% - 148px)',
    marginTop: 20,
  },
  tabRoot: {
    minWidth: 100,
  },
  tabcontent: {
    borderTop: "1px solid #1890ff"
  },
  textBox: {
    border: '1px solid white',
    borderRadius: 12,
    fontSize: 12,
    height: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '45%',
    color: 'white',
    margin: theme.spacing.unit,
  },
  row: {
    height: "auto",

    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default
    }
  },
  cell: {
    padding: '4px 8px 4px 8px'
  },
  flexBox: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#23272f',

    '&.center': {
      alignItems: 'center',
    }
  },
});

class BrokerSettlement extends Component {
  state = {
    total_commission: 0,
    total_value: 0,
    total_executions: 0,
    total_orders: 0,
  };


  getMarketDepth = (account) => {
    sell_orders({query:{_status:0,_company_account: account.account_number}}).then(so => {
      buy_orders({query:{_status:0,_company_account:account.account_number}}).then(bo => {
        this.setState({
          total_orders: so.data.data.length + bo.data.data.length,
        });
      });
    });
  }

  getCompletedTrades = (account) => {
    completed_trades({query:{_company_account:account.account_number}}).then(ct => {
      const { tc, tv } = ct.data.data.reduce(({tc, tv}, d) => ({
        tc: tc + parseFloat(d._buy_commission) + parseFloat(d._sell_commission),
        tv: tv + parseFloat(d._value),
      }), {tc: 0, tv: 0});
      let todayTrades = ct.data.data.filter(t => {
        var dateA = new Date(t._ts_executed), dateB = new Date();
        dateB.setHours(0,0,0,0);
        return (dateA - dateB) >= 0;
      })
      this.setState({
        completed_trades: ct.data.data,
        total_commission: tc,
        total_value: tv,
        total_executions: todayTrades.length,
      });
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectedCompany) {
      const { selectedCompany } = nextProps;
      if (this.state.select !== selectedCompany.id) {
        this.setState({ select: selectedCompany.id });
        this.getMarketDepth(selectedCompany);
        this.getCompletedTrades(selectedCompany);
      }
    }
  }

  render() {
    const { classes } = this.props
    const { total_commission, total_value, total_executions, total_orders } = this.state;

    return (
      <FusePageCarded
        classes={{
          root: classes.layoutRoot
        }}
        header={
          <div />
        }
        leftSidebarContent={
          <WatchList />
        }
        content={
          <div className={classes.content}>
            <div className={classNames(classes.flexBox, classes.dataContainer)}>
              <div style={{width: '50%', height: '100%'}}>
                <div className={classes.flexBox} style={{flexWrap: 'wrap'}}>
                  <div className={classes.textBox}><span>Total Executions:</span><span>{total_executions}</span></div>
                  <div className={classes.textBox}><span>Total Commission:</span><span>{Util.addThousandCommas(total_commission.toFixed(), '0, 0.00')}</span></div>
                  <div className={classes.textBox}><span>Total Value:</span><span>{Util.addThousandCommas(total_value, '0, 0.00')}</span></div>
                  <div className={classes.textBox}><span>Open Orders:</span><span>{total_orders}</span></div>
                </div>
              </div>
              <div style={{width: '50%'}}>
                <OrdersList fullHeight/>
              </div>
            </div>
          </div>
        }
      />
    )
  }
}

const mapStateToProps = state => ({
  selectedCompany: companySelector(state),
});

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(withRouter(BrokerSettlement)));



// WEBPACK FOOTER //
// ./src/main/content/brokersettlement/BrokerSettlement.js